'use client';
import { initializeFirebase } from './index';
import { FirebaseProvider } from './provider';

// Re-export everything from the provider
export * from './provider';

export function FirebaseClientProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <FirebaseProvider {...initializeFirebase()}>{children}</FirebaseProvider>
  );
}
